<!-- src/views/gas/GestionGasDashboard.vue -->
<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Encabezado -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-indigo-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-indigo-600 tracking-widest">Panel de Control</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          <Icon icon="mdi:gas-cylinder" class="text-indigo-600" />
          Panel de Gestión - Gas
          <span class="px-2 sm:px-3 py-0.5 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 text-xs sm:text-sm font-black rounded-lg border border-indigo-200 dark:border-indigo-800">
            {{ fechaSeleccionadaFormateada }}
          </span>
        </h1>
        <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">SYSTEM JJ - Control de Pedidos, Delivery y Pagos de Gas</p>
      </div>

      <div class="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 w-full sm:w-auto">
        <!-- CALENDARIO NATIVO -->
        <div class="relative w-full sm:w-auto">
          <div class="flex items-center gap-2 px-3 sm:px-4 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl cursor-pointer hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm">
            <Icon icon="mdi:calendar-month" class="text-indigo-600 dark:text-indigo-400 text-lg flex-shrink-0" />
            <input
              type="date"
              v-model="fechaInput"
              @change="cambiarFechaDesdeInput"
              class="bg-transparent border-none outline-none text-sm font-medium text-gray-700 dark:text-gray-300 w-[140px] sm:w-[160px] cursor-pointer"
              :max="fechaMaxima"
            />
          </div>
        </div>

        <!-- Botones rápidos -->
        <div class="flex gap-1">
          <button
            @click="cambiarFecha(-1)"
            class="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm"
            title="Día anterior"
          >
            <Icon icon="mdi:chevron-left" class="text-gray-600 dark:text-gray-400 text-base" />
          </button>
          <button
            @click="resetearFechaHoy"
            class="px-2 sm:px-3 py-2 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 rounded-xl text-xs font-bold hover:bg-indigo-200 dark:hover:bg-indigo-800/50 transition-all shadow-sm whitespace-nowrap"
          >
            Hoy
          </button>
          <button
            @click="cambiarFecha(1)"
            class="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm"
            title="Día siguiente"
          >
            <Icon icon="mdi:chevron-right" class="text-gray-600 dark:text-gray-400 text-base" />
          </button>
        </div>

        <!-- Botón Sincronizar -->
        <button
          @click="cargarEstadisticas"
          class="px-3 sm:px-6 py-2 sm:py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-black text-[10px] sm:text-sm tracking-widest transition-all shadow-lg shadow-indigo-500/20 flex items-center gap-2 w-full sm:w-auto justify-center"
          :disabled="cargando"
        >
          <Icon icon="mdi:refresh" :class="{'animate-spin': cargando}" class="text-base sm:text-xl" />
          <span class="hidden sm:inline">{{ cargando ? 'Cargando...' : 'Sincronizar Datos' }}</span>
          <span class="sm:hidden">{{ cargando ? '...' : 'Actualizar' }}</span>
        </button>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- FILA 1: TARJETAS PRINCIPALES DEL GAS (5) -->
    <!-- ============================================================ -->
    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-4 mb-3 sm:mb-6">

      <!-- 1. Pedidos del Día -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-indigo-500/10 rounded-full blur-2xl group-hover:bg-indigo-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-indigo-100 dark:bg-indigo-900/40 rounded-xl sm:rounded-2xl text-indigo-600 dark:text-indigo-300">
            <Icon icon="mdi:clipboard-list" class="text-lg sm:text-2xl" />
          </div>
          <span class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 rounded-lg">{{ fechaEtiqueta }}</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Pedidos del Día</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">{{ statsGas.pedidosHoy }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-indigo-600 dark:text-indigo-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/gas/pedidos')">
          Ver pedidos <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>

      <!-- 2. En Camino -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-orange-500/10 rounded-full blur-2xl group-hover:bg-orange-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-orange-100 dark:bg-orange-900/40 rounded-xl sm:rounded-2xl text-orange-600 dark:text-orange-300">
            <Icon icon="mdi:truck-fast" class="text-lg sm:text-2xl" />
          </div>
          <span class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-orange-50 dark:bg-orange-900/20 text-orange-600 dark:text-orange-400 rounded-lg">EN RUTA</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">En Camino</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">{{ statsGas.pedidosEnCamino }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-orange-600 dark:text-orange-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/gas/asignaciones')">
          Ver asignaciones <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>

      <!-- 3. Completados Hoy -->
      <div class="relative overflow-hidden group bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-emerald-500/30">
        <div class="absolute right-0 bottom-0 opacity-10">
          <Icon icon="mdi:check-decagram" class="text-6xl sm:text-8xl" />
        </div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-white/20 backdrop-blur-md rounded-xl sm:rounded-2xl text-white">
            <Icon icon="mdi:check-circle" class="text-lg sm:text-2xl" />
          </div>
          <span class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-white/20 text-white rounded-lg animate-pulse">OK</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-emerald-100/80 font-medium mb-0.5 sm:mb-1">Completados Hoy</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-white">{{ statsGas.completadosHoy }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-white/90 font-bold">
          <Icon icon="mdi:circle" class="mr-1 text-[6px] animate-pulse" /> {{ fechaEtiqueta }}
        </div>
      </div>

      <!-- 4. Por Cobrar -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-rose-500/10 rounded-full blur-2xl group-hover:bg-rose-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-rose-100 dark:bg-rose-900/40 rounded-xl sm:rounded-2xl text-rose-600 dark:text-rose-300">
            <Icon icon="mdi:cash-clock" class="text-lg sm:text-2xl" />
          </div>
          <span class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-rose-50 dark:bg-rose-900/20 text-rose-600 dark:text-rose-400 rounded-lg">PENDIENTE</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Por Cobrar</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">${{ statsGas.porCobrarUsd.toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-rose-600 dark:text-rose-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/gas/pedidos')">
          Ver deudores <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>

      <!-- 5. Clientes Registrados -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-cyan-500/10 rounded-full blur-2xl group-hover:bg-cyan-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-cyan-100 dark:bg-cyan-900/40 rounded-xl sm:rounded-2xl text-cyan-600 dark:text-cyan-300">
            <Icon icon="mdi:account-group" class="text-lg sm:text-2xl" />
          </div>
          <span class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-cyan-50 dark:bg-cyan-900/20 text-cyan-600 dark:text-cyan-400 rounded-lg">CLIENTES</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Clientes Registrados</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">{{ statsGas.clientesRegistrados }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-cyan-600 dark:text-cyan-400 font-semibold cursor-pointer hover:underline" @click="$router.push('/gas/clientes')">
          Ver clientes <Icon icon="mdi:chevron-right" class="text-sm" />
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- FILA 2: INGRESOS Y CILINDROS -->
    <!-- ============================================================ -->
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4 mb-3 sm:mb-6">

      <!-- Ingresos del Día -->
      <div class="relative overflow-hidden group bg-gradient-to-br from-indigo-600 to-blue-700 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-blue-500/30">
        <div class="absolute right-0 bottom-0 opacity-10">
          <Icon icon="mdi:cash-multiple" class="text-6xl sm:text-8xl" />
        </div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-white/20 backdrop-blur-md rounded-xl sm:rounded-2xl text-white">
            <Icon icon="mdi:currency-usd" class="text-lg sm:text-2xl" />
          </div>
          <span class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-white/20 text-white rounded-lg">{{ fechaEtiqueta }}</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-indigo-100/80 font-medium mb-0.5 sm:mb-1">Ingresos del Día</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-white">${{ statsGas.ingresosDiaUsd.toFixed(2) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-white/90 font-bold">
          <Icon icon="mdi:trending-up" class="mr-1" /> Cobrado hoy
        </div>
      </div>

      <!-- Kilos Despachados -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-amber-500/10 rounded-full blur-2xl group-hover:bg-amber-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-amber-100 dark:bg-amber-900/40 rounded-xl sm:rounded-2xl text-amber-600 dark:text-amber-300">
            <Icon icon="mdi:weight-kilogram" class="text-lg sm:text-2xl" />
          </div>
          <span class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 rounded-lg">KG</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Kilos Despachados</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">{{ statsGas.kilosDespachadosHoy.toFixed(1) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-amber-600 dark:text-amber-400 font-semibold">Hoy</div>
      </div>

      <!-- Litros Despachados -->
      <div class="relative overflow-hidden group bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
        <div class="absolute -right-4 -top-4 w-20 sm:w-24 h-20 sm:h-24 bg-cyan-500/10 rounded-full blur-2xl group-hover:bg-cyan-500/20 transition-colors"></div>
        <div class="flex items-start justify-between mb-2 sm:mb-3">
          <div class="p-2 sm:p-3 bg-cyan-100 dark:bg-cyan-900/40 rounded-xl sm:rounded-2xl text-cyan-600 dark:text-cyan-300">
            <Icon icon="mdi:water" class="text-lg sm:text-2xl" />
          </div>
          <span class="text-[8px] sm:text-[10px] font-bold px-1.5 sm:px-2 py-0.5 sm:py-1 bg-cyan-50 dark:bg-cyan-900/20 text-cyan-600 dark:text-cyan-400 rounded-lg">LITROS</span>
        </div>
        <h3 class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-medium mb-0.5 sm:mb-1">Litros Despachados</h3>
        <p class="text-lg sm:text-2xl lg:text-3xl font-black text-gray-900 dark:text-white">{{ statsGas.litrosDespachadosHoy.toFixed(1) }}</p>
        <div class="mt-2 sm:mt-3 flex items-center text-[8px] sm:text-[10px] text-cyan-600 dark:text-cyan-400 font-semibold">Hoy</div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- 👇 SECCIÓN NUEVA: DISTRIBUCIÓN POR ZONA -->
    <!-- ============================================================ -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div>
          <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
            <Icon icon="mdi:map-marker-multiple" class="mr-2 text-indigo-600" />
            Distribución por Zona ({{ fechaEtiqueta }})
          </h2>
          <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5">
            <span class="font-bold text-indigo-600">{{ reportePorZona.zonas.length }}</span> zonas · 
            <span class="font-bold text-emerald-600">{{ reportePorZona.totales.clientesUnicos }}</span> clientes únicos
          </p>
        </div>
      </div>

      <!-- Tabla de zonas -->
      <div v-if="reportePorZona.zonas.length > 0" class="overflow-x-auto">
        <table class="w-full text-left text-[10px] sm:text-sm">
          <thead>
            <tr class="bg-indigo-600 text-white">
              <th class="px-3 py-2 sm:py-3 font-bold uppercase tracking-wider text-left rounded-l-lg">Zona</th>
              <th class="px-3 py-2 sm:py-3 font-bold uppercase tracking-wider text-center">Clientes</th>
              <th class="px-3 py-2 sm:py-3 font-bold uppercase tracking-wider text-center">% Cli.</th>
              <th class="px-3 py-2 sm:py-3 font-bold uppercase tracking-wider text-right">Monto</th>
              <th class="px-3 py-2 sm:py-3 font-bold uppercase tracking-wider text-center">% Monto</th>
              <th class="px-3 py-2 sm:py-3 font-bold uppercase tracking-wider text-center rounded-r-lg">Ticket</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="z in reportePorZona.zonas" :key="z.zona"
              class="border-b border-gray-100 dark:border-gray-700/50 hover:bg-indigo-50/30 dark:hover:bg-gray-700/20 transition-colors">
              <td class="px-3 py-2 sm:py-3 font-bold text-gray-900 dark:text-white">{{ z.zona }}</td>
              <td class="px-3 py-2 sm:py-3 text-center text-gray-700 dark:text-gray-300">
                <span class="font-black">{{ z.clientesUnicos }}</span>
                <span class="text-gray-400 text-[9px] sm:text-[11px]"> ({{ z.compras }} compras)</span>
              </td>
              <td class="px-3 py-2 sm:py-3 text-center font-bold text-indigo-600">{{ z.pctClientes.toFixed(1) }}%</td>
              <td class="px-3 py-2 sm:py-3 text-right font-black text-gray-900 dark:text-white text-sm">
                Bs. {{ formatearMoneda(z.montoBs) }}
              </td>
              <td class="px-3 py-2 sm:py-3 text-center font-bold text-emerald-600">{{ z.pctMonto.toFixed(2) }}%</td>
              <td class="px-3 py-2 sm:py-3 text-center text-gray-700 dark:text-gray-300">
                Bs. {{ formatearMoneda(z.ticketPromedio) }}
              </td>
            </tr>
          </tbody>
          <tfoot class="bg-gray-900 text-white font-black">
            <tr>
              <td class="px-3 py-3 rounded-l-lg">TOTAL GENERAL</td>
              <td class="px-3 py-3 text-center">
                {{ reportePorZona.totales.clientesUnicos }}
                <span class="text-white/70 text-[10px]"> ({{ reportePorZona.totales.totalCompras }} reg.)</span>
              </td>
              <td class="px-3 py-3 text-center">100%</td>
              <td class="px-3 py-3 text-right">Bs. {{ formatearMoneda(reportePorZona.totales.montoBs) }}</td>
              <td class="px-3 py-3 text-center">100%</td>
              <td class="px-3 py-3 text-center rounded-r-lg">—</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div v-else class="text-center py-8 text-gray-400 dark:text-gray-500">
        <Icon icon="mdi:map-marker-off" class="text-4xl mx-auto mb-2 opacity-50" />
        <p class="text-xs">No hay datos de zonas {{ fechaEtiqueta.toLowerCase() }}</p>
      </div>

      <!-- Barras comparativas -->
      <div v-if="reportePorZona.zonas.length > 0" class="mt-5 pt-4 border-t border-gray-200 dark:border-gray-700">
        <h3 class="text-[10px] sm:text-xs font-black text-gray-500 dark:text-gray-400 uppercase tracking-widest mb-3">
          Comparativo de Ingresos por Zona
        </h3>
        <div class="space-y-2">
          <div v-for="(z, i) in reportePorZona.zonas.slice(0, 8)" :key="z.zona">
            <div class="flex justify-between text-[10px] sm:text-[11px] font-black text-gray-700 dark:text-gray-300 mb-1">
              <span>{{ z.zona }}</span>
              <span>Bs. {{ formatearMoneda(z.montoBs) }}</span>
            </div>
            <div class="h-5 bg-gray-100 dark:bg-gray-700 rounded overflow-hidden">
              <div
                :class="['h-full rounded transition-all duration-500',
                  i === 0 ? 'bg-gradient-to-r from-indigo-600 to-blue-500' :
                  (i === 1 ? 'bg-gradient-to-r from-orange-500 to-amber-500' :
                  'bg-gradient-to-r from-gray-400 to-gray-300')]"
                :style="{ width: (z.montoBs / maxMontoZona) * 100 + '%' }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- 👇 SECCIÓN NUEVA: ANÁLISIS POR DELIVERY -->
    <!-- ============================================================ -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6">
      <div class="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5">
        <div class="p-2 bg-gradient-to-br from-purple-100 to-indigo-100 dark:from-purple-900/40 dark:to-indigo-900/40 rounded-xl">
          <Icon icon="mdi:truck-fast" class="text-purple-600 dark:text-purple-400 text-xl sm:text-2xl" />
        </div>
        <div>
          <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white">
            Análisis por Fuerza de Ventas
          </h2>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-bold">
            <span class="text-purple-600">{{ reportePorDelivery.deliveries.length }}</span> repartidor{{ reportePorDelivery.deliveries.length === 1 ? '' : 'es' }}
            · <span class="text-indigo-600">{{ zonasCubiertasPorDelivery }}</span> zonas cubiertas
          </p>
        </div>
      </div>

      <div v-if="reportePorDelivery.deliveries.length === 0" class="text-center py-8 text-gray-400 dark:text-gray-500">
        <Icon icon="mdi:truck-off" class="text-4xl mx-auto mb-2 opacity-50" />
        <p class="text-xs">No hay deliveries con pedidos asignados {{ fechaEtiqueta.toLowerCase() }}</p>
      </div>

      <div v-else class="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
        <div v-for="(d, i) in reportePorDelivery.deliveries" :key="d.idDelivery"
          class="bg-gray-50 dark:bg-gray-900/40 rounded-2xl overflow-hidden border border-gray-100 dark:border-gray-700">

          <!-- Header -->
          <div :class="[
            'px-4 py-3 flex justify-between items-center text-white',
            i % 2 === 0
              ? 'bg-gradient-to-r from-purple-600 to-indigo-600'
              : 'bg-gradient-to-r from-gray-600 to-slate-600'
          ]">
            <div class="flex items-center gap-2 min-w-0">
              <Icon icon="mdi:account-circle" class="text-2xl flex-shrink-0" />
              <div class="min-w-0">
                <p class="font-black text-sm truncate">{{ d.nombre }}</p>
                <p class="text-[10px] opacity-80">{{ d.pedidos }} pedido{{ d.pedidos === 1 ? '' : 's' }}</p>
              </div>
            </div>
            <span class="bg-white/20 px-2 py-1 rounded text-[9px] font-black uppercase tracking-widest whitespace-nowrap">
              {{ d.zonasCount }} zona{{ d.zonasCount === 1 ? '' : 's' }}
            </span>
          </div>

          <!-- Stats -->
          <div class="p-3 sm:p-4 border-b border-gray-200 dark:border-gray-700">
            <div class="grid grid-cols-3 gap-2 text-center">
              <div>
                <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Pedidos</p>
                <p class="text-lg sm:text-xl font-black text-gray-900 dark:text-white">{{ d.pedidos }}</p>
              </div>
              <div>
                <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Clientes</p>
                <p class="text-lg sm:text-xl font-black text-gray-900 dark:text-white">{{ d.clientesUnicos }}</p>
              </div>
              <div>
                <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest">Ticket</p>
                <p class="text-xs sm:text-sm font-black text-gray-900 dark:text-white">
                  Bs. {{ formatearMoneda(d.ticketPromedio) }}
                </p>
              </div>
            </div>
          </div>

          <!-- Desglose por zona -->
          <div class="p-3 sm:p-4">
            <p class="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-2">
              Desglose por Zona
            </p>
            <div class="space-y-1">
              <div v-for="z in d.zonasDetalle" :key="z.zona"
                class="flex justify-between items-center text-[10px] sm:text-[11px] py-1 dark:text-gray-300">
                <span class="font-bold truncate">{{ z.zona }}</span>
                <span class="text-gray-500 dark:text-gray-400 mx-2 whitespace-nowrap">
                  {{ z.clientesUnicos }} cli.
                </span>
                <span class="font-black text-gray-900 dark:text-white whitespace-nowrap">
                  Bs. {{ formatearMoneda(z.montoBs) }}
                </span>
              </div>
            </div>
          </div>

          <!-- Subtotal -->
          <div class="bg-gray-900 text-white px-4 py-2.5 flex justify-between items-center text-[10px] sm:text-xs font-black">
            <span class="truncate">SUBTOTAL {{ d.nombre.toUpperCase() }}</span>
            <span class="whitespace-nowrap">{{ d.pedidos }} ped. · Bs. {{ formatearMoneda(d.montoBs) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- GRÁFICA: DISTRIBUCIÓN DE MÉTODOS DE PAGO (DONUT) -->
    <!-- ============================================================ -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div>
          <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
            <Icon icon="mdi:chart-donut" class="mr-2 text-indigo-600" />
            Distribución de Métodos de Pago ({{ fechaEtiqueta }})
          </h2>
          <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5">
            Total cobrado: <span class="font-bold text-indigo-600">${{ totalIngresosDia.toFixed(2) }}</span>
          </p>
        </div>
        <div class="flex items-center bg-gray-100 dark:bg-gray-700 p-1 rounded-xl sm:rounded-2xl">
          <button
            @click="monedaActiva = 'USD'"
            :class="['px-3 sm:px-4 py-1.5 sm:py-2 text-[10px] sm:text-xs font-bold rounded-lg sm:rounded-xl transition-all', monedaActiva === 'USD' ? 'bg-white dark:bg-gray-600 text-indigo-600 dark:text-white shadow-md' : 'text-gray-500 dark:text-gray-400']"
          >
            USD ($)
          </button>
          <button
            v-if="tasaUbcv"
            @click="monedaActiva = 'BS'"
            :class="['px-3 sm:px-4 py-1.5 sm:py-2 text-[10px] sm:text-xs font-bold rounded-lg sm:rounded-xl transition-all', monedaActiva === 'BS' ? 'bg-white dark:bg-gray-600 text-indigo-600 dark:text-white shadow-md' : 'text-gray-500 dark:text-gray-400']"
          >
            Bs (UBCV)
          </button>
        </div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        <!-- Donut -->
        <div class="w-full h-[280px] sm:h-[320px] flex items-center justify-center">
          <apexchart
            v-if="cargado"
            type="donut"
            height="100%"
            width="100%"
            :options="chartOptionsMetodosPago"
            :series="chartSeriesMetodosPago"
          ></apexchart>
          <div v-else class="flex items-center justify-center h-full">
            <Icon icon="mdi:loading" class="text-4xl animate-spin text-indigo-600" />
          </div>
        </div>

        <!-- Barras -->
        <div class="w-full h-[280px] sm:h-[320px]">
          <apexchart
            v-if="cargado"
            type="bar"
            height="100%"
            width="100%"
            :options="chartOptionsBarrasMetodosPago"
            :series="chartSeriesBarrasMetodosPago"
          ></apexchart>
          <div v-else class="flex items-center justify-center h-full">
            <Icon icon="mdi:loading" class="text-4xl animate-spin text-indigo-600" />
          </div>
        </div>
      </div>

      <!-- Tarjetas de detalle -->
      <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-4 mt-4 sm:mt-6">
        <div
          v-for="(val, label) in metodosPago"
          :key="label"
          class="p-2 sm:p-4 rounded-xl sm:rounded-2xl border transition-all duration-200"
          :class="[
            val > 0 ? 'bg-gray-50 dark:bg-gray-700/30 border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md' : 'bg-gray-50/40 dark:bg-gray-800/20 border-gray-100/50 dark:border-gray-800 opacity-40'
          ]"
        >
          <div class="flex items-center gap-2 sm:gap-3">
            <div class="p-1.5 sm:p-2.5 rounded-lg sm:rounded-xl flex-shrink-0" :class="getBadgeStyle(label)">
              <Icon :icon="getIconStyle(label)" class="text-base sm:text-lg" />
            </div>
            <div class="min-w-0">
              <p class="text-[9px] sm:text-[11px] text-gray-500 dark:text-gray-400 font-semibold truncate leading-tight">{{ label }}</p>
              <p class="text-xs sm:text-sm font-black text-gray-800 dark:text-white truncate">
                ${{ val.toFixed(2) }}
              </p>
              <p class="text-[8px] sm:text-[10px] text-gray-400 dark:text-gray-500 font-medium truncate" v-if="tasaUbcv && val > 0">
                Bs. {{ (val * tasaUbcv).toLocaleString('es-VE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- SECCIÓN: PEDIDOS DEL DÍA -->
    <!-- ============================================================ -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div>
          <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white flex items-center">
            <Icon icon="mdi:clipboard-list" class="mr-2 text-indigo-600" />
            Pedidos {{ fechaEtiqueta.toLowerCase() }}
          </h2>
          <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 mt-0.5">
            <span class="font-bold text-indigo-600">{{ pedidosFiltrados.length }}</span> pedidos registrados
          </p>
        </div>
        <div class="text-right bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800/30 rounded-xl sm:rounded-2xl px-3 sm:px-5 py-2 sm:py-3 w-full sm:w-auto">
          <p class="text-[8px] sm:text-[10px] text-indigo-500 uppercase font-bold tracking-wider">Total Pedidos</p>
          <p class="text-base sm:text-2xl font-black text-indigo-600 dark:text-indigo-400">{{ pedidosFiltrados.length }}</p>
        </div>
      </div>

      <!-- Filtros -->
      <div class="flex flex-wrap gap-2 mb-4">
        <button
          @click="filtroEstado = 'todos'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstado === 'todos' ? 'bg-indigo-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'"
        >
          Todos ({{ pedidos.length }})
        </button>
        <button
          @click="filtroEstado = 'PENDIENTE'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstado === 'PENDIENTE' ? 'bg-amber-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'"
        >
          ⏳ Pendientes ({{ pedidosPendientes.length }})
        </button>
        <button
          @click="filtroEstado = 'EN_CAMINO'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstado === 'EN_CAMINO' ? 'bg-orange-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'"
        >
          🚚 En Camino ({{ pedidosEnCamino.length }})
        </button>
        <button
          @click="filtroEstado = 'COMPLETADO'; paginaActual = 1"
          class="px-3 py-1.5 text-xs font-bold rounded-full transition-all"
          :class="filtroEstado === 'COMPLETADO' ? 'bg-emerald-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'"
        >
          ✅ Completados ({{ pedidosCompletados.length }})
        </button>
      </div>

      <!-- Tabla -->
      <div class="overflow-x-auto">
        <table class="w-full text-left text-[10px] sm:text-sm">
          <thead>
            <tr class="border-b border-gray-200 dark:border-gray-700">
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">N° Pedido</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Cliente</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Zona</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider text-center">Estado</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider text-center">Cant.</th>
              <th class="pb-2 sm:pb-3 font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider text-right">Total USD</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(pedido, index) in pedidosPaginados"
              :key="pedido.idPedidoRecarga || index"
              class="border-b border-gray-100 dark:border-gray-700/50 hover:bg-gray-50 dark:hover:bg-gray-700/20 transition-colors"
            >
              <td class="py-2 sm:py-3">
                <span class="font-bold text-gray-800 dark:text-white">{{ pedido.numeroPedido }}</span>
              </td>
              <td class="py-2 sm:py-3 text-gray-700 dark:text-gray-300">{{ pedido.nombreCliente || '—' }}</td>
              <td class="py-2 sm:py-3 text-gray-700 dark:text-gray-300">{{ pedido.nombreZona || '—' }}</td>
              <td class="py-2 sm:py-3 text-center">
                <span class="px-2 py-0.5 rounded-full text-[8px] sm:text-[10px] font-bold" :class="colorEstado(pedido.estado)">
                  {{ pedido.estado }}
                </span>
              </td>
              <td class="py-2 sm:py-3 text-center font-bold text-gray-800 dark:text-white">
                {{ getCantidadTotal(pedido) }}
              </td>
              <td class="py-2 sm:py-3 text-right font-black text-emerald-600">
                ${{ Number(pedido.totalUsd || 0).toFixed(2) }}
              </td>
            </tr>
            <tr v-if="pedidosPaginados.length === 0">
              <td colspan="6" class="py-6 text-center text-gray-400 dark:text-gray-500 text-xs sm:text-sm">
                <Icon icon="mdi:inbox-outline" class="text-3xl sm:text-4xl mx-auto mb-2 opacity-50" />
                No hay pedidos registrados {{ fechaEtiqueta.toLowerCase() }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      <div v-if="pedidosFiltrados.length > itemsPorPagina" class="mt-4 flex justify-between items-center">
        <button
          @click="paginaActual = Math.max(1, paginaActual - 1)"
          :disabled="paginaActual === 1"
          class="px-3 py-1 text-sm font-bold rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Anterior
        </button>
        <span class="text-sm text-gray-500 dark:text-gray-400">
          Página {{ paginaActual }} de {{ totalPaginas }}
        </span>
        <button
          @click="paginaActual = Math.min(totalPaginas, paginaActual + 1)"
          :disabled="paginaActual === totalPaginas"
          class="px-3 py-1 text-sm font-bold rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Siguiente
        </button>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- SECCIÓN: DELIVERY DISPONIBLES -->
    <!-- ============================================================ -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl p-3 sm:p-5 shadow-xl border border-gray-100 dark:border-gray-700 mb-4 sm:mb-6">
      <div class="flex items-center gap-2 sm:gap-3 mb-4">
        <div class="p-2 bg-orange-100 dark:bg-orange-900/50 rounded-xl">
          <Icon icon="mdi:truck-fast" class="text-orange-600 dark:text-orange-400 text-xl sm:text-2xl" />
        </div>
        <div>
          <h2 class="text-base sm:text-xl font-black text-gray-900 dark:text-white">Delivery Disponibles</h2>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 font-bold">Repartidores listos para asignar</p>
        </div>
        <span class="ml-auto bg-orange-600 text-white font-black text-[10px] sm:text-xs px-2.5 py-1 rounded-lg shadow-sm">
          {{ deliveriesDisponibles.length }}
        </span>
      </div>

      <div v-if="deliveriesDisponibles.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        <div
          v-for="d in deliveriesDisponibles"
          :key="d.idDelivery"
          class="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-900/40 rounded-xl border border-gray-100 dark:border-gray-700"
        >
          <div class="p-2 bg-orange-100 dark:bg-orange-900/40 rounded-xl text-orange-600 dark:text-orange-300">
            <Icon icon="mdi:account-circle" class="text-xl" />
          </div>
          <div class="flex-1 min-w-0">
            <p class="font-bold text-gray-900 dark:text-white text-xs truncate">{{ d.nombre || 'Delivery' }}</p>
            <p class="text-[10px] text-gray-500 dark:text-gray-400">{{ d.telefono || '—' }}</p>
          </div>
          <span class="px-2 py-0.5 rounded-full text-[9px] font-black bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400">
            DISPONIBLE
          </span>
        </div>
      </div>
      <div v-else class="text-center py-6 text-gray-400 text-xs">
        <Icon icon="mdi:truck-off" class="text-3xl mx-auto mb-2 opacity-50" />
        No hay delivery disponibles ahora
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- ACCESOS RÁPIDOS -->
    <!-- ============================================================ -->
    <h2 class="text-base sm:text-xl font-bold text-gray-800 dark:text-white mb-3 sm:mb-6 flex items-center">
      <Icon icon="mdi:view-grid-outline" class="mr-2 text-indigo-600" />
      Accesos Rápidos
    </h2>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      <button @click="$router.push('/gas/pedidos')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-indigo-500 dark:hover:border-indigo-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-indigo-100 dark:bg-indigo-900/30 rounded-xl sm:rounded-2xl text-indigo-600 dark:text-indigo-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:clipboard-list" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Pedidos</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Gestionar pedidos</p>
        </div>
      </button>

      <button @click="$router.push('/gas/pedidos/nuevo')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-emerald-500 dark:hover:border-emerald-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-emerald-100 dark:bg-emerald-900/30 rounded-xl sm:rounded-2xl text-emerald-600 dark:text-emerald-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:plus-circle" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Nuevo Pedido</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Registrar recarga</p>
        </div>
      </button>

      <button @click="$router.push('/gas/asignaciones')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-orange-500 dark:hover:border-orange-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-orange-100 dark:bg-orange-900/30 rounded-xl sm:rounded-2xl text-orange-600 dark:text-orange-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:truck-delivery" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Asignaciones</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Asignar delivery</p>
        </div>
      </button>

      <button @click="$router.push('/gas/reportes')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-purple-500 dark:hover:border-purple-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-purple-100 dark:bg-purple-900/30 rounded-xl sm:rounded-2xl text-purple-600 dark:text-purple-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:chart-line" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Reportes</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Análisis y PDF</p>
        </div>
      </button>

      <button @click="$router.push('/gas/clientes')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-cyan-500 dark:hover:border-cyan-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-cyan-100 dark:bg-cyan-900/30 rounded-xl sm:rounded-2xl text-cyan-600 dark:text-cyan-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:account-group" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Clientes</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Base de clientes</p>
        </div>
      </button>

      <button @click="$router.push('/gas/delivery')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-amber-500 dark:hover:border-amber-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-amber-100 dark:bg-amber-900/30 rounded-xl sm:rounded-2xl text-amber-600 dark:text-amber-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:truck-fast" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Delivery</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Repartidores</p>
        </div>
      </button>

      <button @click="$router.push('/gas/pagos')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-teal-500 dark:hover:border-teal-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-teal-100 dark:bg-teal-900/30 rounded-xl sm:rounded-2xl text-teal-600 dark:text-teal-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:cash-register" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Pagos</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Recibos y cobros</p>
        </div>
      </button>

      <button @click="$router.push('/gas/zonas')" class="flex items-center p-3 sm:p-5 bg-white dark:bg-gray-800 rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 dark:border-gray-700 hover:border-rose-500 dark:hover:border-rose-500 transition-all group text-left transform hover:-translate-y-1 hover:shadow-2xl">
        <div class="p-2 sm:p-4 bg-rose-100 dark:bg-rose-900/30 rounded-xl sm:rounded-2xl text-rose-600 dark:text-rose-400 mr-3 sm:mr-4 group-hover:scale-110 transition-transform">
          <Icon icon="mdi:map-marker-multiple" class="text-2xl sm:text-3xl" />
        </div>
        <div>
          <h4 class="font-bold text-gray-900 dark:text-white text-sm sm:text-base">Zonas</h4>
          <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">Cobertura</p>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import VueApexCharts from "vue3-apexcharts";
import {
  obtenerPedidosRecarga,
  obtenerClientesGas,
  obtenerDeliveries,
  obtenerPagosPedidos,
  obtenerTasaActual,
  obtenerAsignaciones
} from '@/api/gas.js';
import {
  calcularReportePorZona,
  calcularReportePorDelivery
} from '@/utils/reporteGasConsolidado';

export default {
  name: 'GestionGasDashboard',
  components: { Icon, apexchart: VueApexCharts },
  data() {
    return {
      fechaInput: new Date().toLocaleDateString('sv-SE'),
      fechaMaxima: new Date().toLocaleDateString('sv-SE'),

      cargando: false,
      cargado: false,

      pedidos: [],
      pagos: [],
      clientes: [],
      deliveries: [],
      asignaciones: [],

      tasaUbcv: null,
      monedaActiva: 'USD',

      statsGas: {
        pedidosHoy: 0,
        pedidosEnCamino: 0,
        completadosHoy: 0,
        porCobrarUsd: 0,
        clientesRegistrados: 0,
        ingresosDiaUsd: 0,
        kilosDespachadosHoy: 0,
        litrosDespachadosHoy: 0
      },

      metodosPago: {
        'Efectivo': 0,
        'Transferencia': 0,
        'Pago Móvil': 0,
        'Zelle': 0,
        'USDT': 0,
        'Otros': 0
      },

      filtroEstado: 'todos',
      paginaActual: 1,
      itemsPorPagina: 10,

      intervalRefresh: null
    };
  },
  computed: {
    fechaSeleccionadaFormateada() {
      if (!this.fechaInput) return 'Seleccionar fecha';
      const partes = this.fechaInput.split('-');
      const d = new Date(partes[0], partes[1] - 1, partes[2]);
      return d.toLocaleDateString('es-VE', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    fechaEtiqueta() {
      if (!this.fechaInput) return 'HOY';
      const partes = this.fechaInput.split('-');
      const d = new Date(partes[0], partes[1] - 1, partes[2]);
      const hoy = new Date();
      if (d.toDateString() === hoy.toDateString()) return 'HOY';
      return d.toLocaleDateString('es-VE', { day: '2-digit', month: 'short' }).toUpperCase();
    },

    pedidosDelDia() {
      if (!this.fechaInput) return this.pedidos;
      return this.pedidos.filter(p => {
        const fecha = p.fechaPedido || p.fechaCompletado;
        if (!fecha) return false;
        const f = new Date(fecha).toLocaleDateString('sv-SE');
        return f === this.fechaInput;
      });
    },

    pedidosFiltrados() {
      if (this.filtroEstado === 'todos') return this.pedidosDelDia;
      return this.pedidosDelDia.filter(p => p.estado === this.filtroEstado);
    },

    pedidosPendientes() {
      return this.pedidosDelDia.filter(p => p.estado === 'PENDIENTE');
    },

    pedidosEnCamino() {
      return this.pedidosDelDia.filter(p => ['EN_CAMINO', 'ASIGNADO', 'EN_PROCESO'].includes(p.estado));
    },

    pedidosCompletados() {
      return this.pedidosDelDia.filter(p => p.estado === 'COMPLETADO');
    },

    pedidosPaginados() {
      const inicio = (this.paginaActual - 1) * this.itemsPorPagina;
      return this.pedidosFiltrados.slice(inicio, inicio + this.itemsPorPagina);
    },

    totalPaginas() {
      return Math.ceil(this.pedidosFiltrados.length / this.itemsPorPagina);
    },

    deliveriesDisponibles() {
      return this.deliveries.filter(d => d.disponible === true || d.estado === 'disponible');
    },

    totalIngresosDia() {
      return Object.values(this.metodosPago).reduce((s, v) => s + v, 0);
    },

    // ============================================================
    // 👇 NUEVOS: REPORTE POR ZONA Y POR DELIVERY (filtrado por día)
    // ============================================================
    reportePorZona() {
      return calcularReportePorZona(this.pedidosDelDia);
    },

    reportePorDelivery() {
      return calcularReportePorDelivery(
        this.pedidosDelDia,
        this.asignaciones,
        this.deliveries
      );
    },

    maxMontoZona() {
      if (this.reportePorZona.zonas.length === 0) return 1;
      return Math.max(...this.reportePorZona.zonas.map(z => z.montoBs));
    },

    zonasCubiertasPorDelivery() {
      const set = new Set();
      this.reportePorDelivery.deliveries.forEach(d => {
        d.zonas.forEach(z => set.add(z));
      });
      return set.size;
    },

    // === GRÁFICAS ===
    chartSeriesMetodosPago() {
      const labels = Object.keys(this.metodosPago);
      const factor = this.monedaActiva === 'BS' && this.tasaUbcv ? this.tasaUbcv : 1;
      return labels.map(l => parseFloat((this.metodosPago[l] * factor).toFixed(2)));
    },

    chartOptionsMetodosPago() {
      const isDark = document.documentElement.classList.contains('dark');
      const isBs = this.monedaActiva === 'BS';
      return {
        chart: { type: 'donut', background: 'transparent', animations: { enabled: false } },
        labels: Object.keys(this.metodosPago),
        colors: ['#10B981', '#3B82F6', '#8B5CF6', '#6366F1', '#14B8A6', '#9CA3AF'],
        legend: {
          position: 'bottom',
          labels: { colors: isDark ? '#E5E7EB' : '#374151' },
          fontSize: '11px',
          fontFamily: 'Lexend, sans-serif',
          fontWeight: 600
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val.toFixed(1)}%`,
          style: { fontSize: '10px', fontWeight: 'bold' }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '65%',
              labels: {
                show: true,
                name: { fontSize: '12px', color: isDark ? '#9CA3AF' : '#6B7280' },
                value: {
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: isDark ? '#FFFFFF' : '#111827',
                  formatter: (val) => {
                    const n = parseFloat(val);
                    return isBs ? `Bs. ${n.toLocaleString('es-VE', { minimumFractionDigits: 2 })}` : `$${n.toFixed(2)}`;
                  }
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: isDark ? '#9CA3AF' : '#6B7280',
                  formatter: () => {
                    const total = this.totalIngresosDia;
                    return isBs ? `Bs. ${(total * (this.tasaUbcv || 1)).toLocaleString('es-VE', { minimumFractionDigits: 2 })}` : `$${total.toFixed(2)}`;
                  }
                }
              }
            }
          }
        },
        tooltip: {
          theme: isDark ? 'dark' : 'light',
          y: {
            formatter: (val) => {
              return isBs ? `Bs. ${val.toLocaleString('es-VE', { minimumFractionDigits: 2 })}` : `$${val.toFixed(2)}`;
            }
          }
        }
      };
    },

    chartSeriesBarrasMetodosPago() {
      const labels = Object.keys(this.metodosPago);
      const factor = this.monedaActiva === 'BS' && this.tasaUbcv ? this.tasaUbcv : 1;
      const data = labels.map(l => parseFloat((this.metodosPago[l] * factor).toFixed(2)));
      return [{ name: 'Monto', data }];
    },

    chartOptionsBarrasMetodosPago() {
      const isDark = document.documentElement.classList.contains('dark');
      const isBs = this.monedaActiva === 'BS';
      return {
        chart: { type: 'bar', toolbar: { show: false }, background: 'transparent', animations: { enabled: false } },
        plotOptions: {
          bar: { distributed: true, borderRadius: 8, columnWidth: '55%', dataLabels: { position: 'top' } }
        },
        colors: ['#10B981', '#3B82F6', '#8B5CF6', '#6366F1', '#14B8A6', '#9CA3AF'],
        dataLabels: {
          enabled: true,
          formatter: (val) => {
            if (val === 0) return '';
            return isBs ? `Bs.${val.toFixed(2)}` : `$${val.toFixed(2)}`;
          },
          offsetY: -20,
          style: {
            fontSize: '10px',
            fontFamily: 'Lexend, sans-serif',
            fontWeight: 'bold',
            colors: [isDark ? '#E5E7EB' : '#374151']
          }
        },
        legend: { show: false },
        xaxis: {
          categories: Object.keys(this.metodosPago),
          labels: {
            style: {
              colors: isDark ? '#9CA3AF' : '#4B5563',
              fontSize: '10px',
              fontFamily: 'Lexend, sans-serif',
              fontWeight: 600
            }
          }
        },
        yaxis: {
          labels: {
            style: { colors: isDark ? '#9CA3AF' : '#4B5563' },
            formatter: (value) => isBs ? `Bs.${value.toLocaleString('es-VE')}` : `$${value.toFixed(2)}`
          }
        },
        theme: { mode: isDark ? 'dark' : 'light' },
        tooltip: {
          theme: isDark ? 'dark' : 'light',
          y: {
            formatter: (value) => isBs ? `Bs. ${value.toLocaleString('es-VE', { minimumFractionDigits: 2 })}` : `$${value.toFixed(2)}`
          }
        },
        grid: { borderColor: isDark ? '#374151' : '#F3F4F6' }
      };
    }
  },
  async mounted() {
    await this.cargarEstadisticas();
    this.intervalRefresh = setInterval(() => { this.cargarEstadisticas(); }, 30000);
    this.$nextTick(() => { setTimeout(() => { this.cargado = true; }, 100); });
  },
  beforeUnmount() {
    if (this.intervalRefresh) clearInterval(this.intervalRefresh);
  },
  methods: {
    colorEstado(estado) {
      const map = {
        'PENDIENTE': 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
        'CONFIRMADO': 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
        'ASIGNADO': 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
        'EN_CAMINO': 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
        'EN_PROCESO': 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
        'COMPLETADO': 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400',
        'CANCELADO': 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400',
        'RECHAZADO': 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400'
      };
      return map[estado] || 'bg-gray-100 text-gray-500';
    },

    getBadgeStyle(label) {
      if (label.includes('Efectivo')) return 'bg-emerald-100 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400';
      if (label.includes('Transferencia')) return 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400';
      if (label.includes('Pago Móvil') || label.includes('Pago Movil')) return 'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400';
      if (label.includes('Zelle')) return 'bg-indigo-100 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400';
      if (label.includes('USDT')) return 'bg-teal-100 text-teal-600 dark:bg-teal-900/30 dark:text-teal-400';
      return 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
    },

    getIconStyle(label) {
      if (label.includes('Efectivo')) return 'mdi:cash';
      if (label.includes('Transferencia')) return 'mdi:bank-transfer';
      if (label.includes('Pago Móvil') || label.includes('Pago Movil')) return 'mdi:cellphone';
      if (label.includes('Zelle')) return 'mdi:alpha-z-circle';
      if (label.includes('USDT')) return 'mdi:currency-usd-circle';
      return 'mdi:cash-multiple';
    },

    clasificarMetodoPago(metodo) {
      const m = String(metodo || '').toLowerCase();
      if (m.includes('efectivo') || m.includes('cash')) return 'Efectivo';
      if (m.includes('pago_movil') || m.includes('pago movil') || m.includes('pagomovil')) return 'Pago Móvil';
      if (m.includes('transferencia') || m.includes('transfer')) return 'Transferencia';
      if (m.includes('zelle')) return 'Zelle';
      if (m.includes('usdt')) return 'USDT';
      return 'Otros';
    },

    formatearMoneda(valor) {
      if (valor === null || valor === undefined) return '0.00';
      const num = Number(valor);
      if (isNaN(num)) return '0.00';
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(num);
    },

    getCantidadTotal(pedido) {
      if (!pedido || !Array.isArray(pedido.detalles)) return 0;
      return pedido.detalles.reduce((sum, d) => sum + (Number(d.cantidad) || 0), 0);
    },

    getKilosTotales(pedido) {
      if (!pedido || !Array.isArray(pedido.detalles)) return 0;
      return pedido.detalles.reduce(
        (sum, d) => sum + ((Number(d.kilogramos) || 0) * (Number(d.cantidad) || 0)), 0
      );
    },

    getLitrosTotales(pedido) {
      if (!pedido || !Array.isArray(pedido.detalles)) return 0;
      return pedido.detalles.reduce(
        (sum, d) => sum + ((Number(d.litros) || 0) * (Number(d.cantidad) || 0)), 0
      );
    },

    cambiarFecha(delta) {
      if (!this.fechaInput) this.fechaInput = new Date().toLocaleDateString('sv-SE');
      const partes = this.fechaInput.split('-');
      const d = new Date(partes[0], partes[1] - 1, partes[2]);
      d.setDate(d.getDate() + delta);
      const hoy = new Date();
      if (d > hoy) d.setTime(hoy.getTime());
      this.fechaInput = d.toLocaleDateString('sv-SE');
      this.calcularEstadisticasDelDia();
    },

    cambiarFechaDesdeInput() {
      if (this.fechaInput) {
        const hoy = new Date().toLocaleDateString('sv-SE');
        if (this.fechaInput > hoy) this.fechaInput = hoy;
        this.calcularEstadisticasDelDia();
      }
    },

    resetearFechaHoy() {
      this.fechaInput = new Date().toLocaleDateString('sv-SE');
      this.calcularEstadisticasDelDia();
    },

    calcularEstadisticasDelDia() {
      const delDia = this.pedidosDelDia;
      const completados = delDia.filter(p => p.estado === 'COMPLETADO');
      const enCamino = delDia.filter(p => ['EN_CAMINO', 'ASIGNADO', 'EN_PROCESO'].includes(p.estado));

      const ingresosDia = completados.reduce((s, p) => s + Number(p.totalUsd || 0), 0);
      const kilos = completados.reduce((s, p) => s + this.getKilosTotales(p), 0);
      const litros = completados.reduce((s, p) => s + this.getLitrosTotales(p), 0);
      const porCobrar = this.pedidos.reduce((s, p) => s + Number(p.saldoPendienteUsd || 0), 0);

      this.metodosPago = {
        'Efectivo': 0, 'Transferencia': 0, 'Pago Móvil': 0,
        'Zelle': 0, 'USDT': 0, 'Otros': 0
      };

      const fechaStr = this.fechaInput;
      const pagosDelDia = this.pagos.filter(pg => {
        const fPago = pg.fechaPago || pg.fecha_pago || '';
        return fPago.startsWith(fechaStr);
      });

      pagosDelDia.forEach(pg => {
        const metodo = this.clasificarMetodoPago(pg.metodoPago);
        const monto = Number(pg.montoUsd || pg.monto_usd || 0);
        this.metodosPago[metodo] += monto;
      });

      this.statsGas = {
        pedidosHoy: delDia.length,
        pedidosEnCamino: enCamino.length,
        completadosHoy: completados.length,
        porCobrarUsd: porCobrar,
        clientesRegistrados: this.clientes.length,
        ingresosDiaUsd: ingresosDia,
        kilosDespachadosHoy: kilos,
        litrosDespachadosHoy: litros
      };
    },

    async cargarEstadisticas() {
      this.cargando = true;
      try {
        const [resPedidos, resClientes, resDeliveries, resPagos, resTasa, resAsig] = await Promise.all([
          obtenerPedidosRecarga(),
          obtenerClientesGas(),
          obtenerDeliveries('disponibles'),
          obtenerPagosPedidos(),
          obtenerTasaActual(),
          obtenerAsignaciones()
        ]);

        if (resPedidos?.success) this.pedidos = Array.isArray(resPedidos.data) ? resPedidos.data : [];
        if (resClientes?.success) this.clientes = Array.isArray(resClientes.data) ? resClientes.data : [];
        if (resDeliveries?.success) this.deliveries = Array.isArray(resDeliveries.data) ? resDeliveries.data : [];
        if (resPagos?.success) this.pagos = Array.isArray(resPagos.data) ? resPagos.data : [];
        if (resAsig?.success) this.asignaciones = Array.isArray(resAsig.data) ? resAsig.data : [];
        if (resTasa?.success && resTasa.data) this.tasaUbcv = Number(resTasa.data.precioUsdBs || resTasa.data.tasaBsUsd || 0) || null;

        this.calcularEstadisticasDelDia();
      } catch (error) {
        console.error('❌ Error cargando estadísticas de gas:', error);
      } finally {
        this.cargando = false;
      }
    }
  }
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }

input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(0.5);
  cursor: pointer;
}
.dark input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(0.8);
}
input[type="date"]::-webkit-datetime-edit {
  color: inherit;
}
</style>